import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'

// Check if storage is available and handle gracefully
const isStorageAvailable = () => {
  try {
    if (typeof window === 'undefined') return false;
    const test = '__storage_test__';
    window.localStorage.setItem(test, 'test');
    window.localStorage.removeItem(test);
    return true;
  } catch {
    return false;
  }
};

// Disable storage-dependent features if storage is not available
if (!isStorageAvailable()) {
  console.warn('localStorage is not available. Some features may be limited.');
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 0, // Disable garbage collection to avoid any storage operations
      staleTime: 0, // Always refetch to avoid caching issues
      retry: false, // Disable retries that might involve storage
    },
  },
})

createRoot(document.body).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>
)